
import {useState, useEffect} from "react"
import API from "../API"
import { isPersistedState } from '../helpers';

export const useMovieFetch = (movieId) => {
    const [ state, setState ] = useState({})
    const [ loading, setLoading ] = useState(true)
    const [error, setError] = useState(false)

    useEffect(() => {
        const fetchMovie = async () => {
            try{
                setLoading(true)
                setError(false)
                    const movie = await API.fetchMovie(movieId)
                    const credits = await API.fetchCredits(movieId)
                    //Get directors only
                    const directors = credits.crew.filter(member => member.job === "Director")
                    setState({
                        ...movie,
                        theActors: credits.cast,
                        directors
                    })
                setLoading(false)
            }catch(e) {
                setError(true)
            }
        }
        const sessionState = isPersistedState(movieId)
        if (sessionState){
            setState(sessionState)
            setLoading(false)
            return;
        }
        fetchMovie()
    }, [movieId])

    //write to session storage
    useEffect(() => {
        sessionStorage.setItem(movieId, JSON.stringify(state)) // cos we can only write a string to the session storage
    }, [movieId, state])
    return { state, loading, error }
}
